import { CONFERENCE_JOINED, CONFERENCE_WILL_LEAVE } from '../base/conference/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { cleanupRoomTimeLimitTimers, hideFinalCountdown, hideRoomTimeLimitWarning, setRoomStartTime, startRoomTimeLimitTimers } from './actions';
console.log('🔧 [ROOM TIME LIMIT] Middleware loaded and registered');
// Store roomStartTime globally to handle reconnects
let cachedRoomStartTime = null;
let conferenceJoinedCount = 0;
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_JOINED: {
            conferenceJoinedCount++;
            console.log(`🎯 [ROOM TIME LIMIT] CONFERENCE_JOINED event received (count: ${conferenceJoinedCount})`);
            console.log('🎯 [ROOM TIME LIMIT] Stack trace:', new Error().stack);
            const state = store.getState()['features/room-time-limit'];
            let { roomStartTime } = state;
            console.log('📊 [ROOM TIME LIMIT] Current state:', state);
            console.log('📊 [ROOM TIME LIMIT] Cached roomStartTime:', cachedRoomStartTime);
            console.log('📊 [ROOM TIME LIMIT] Full Redux state keys:', Object.keys(store.getState()));
            // If roomStartTime is not in state but we have a cached value (reconnect scenario)
            if (!roomStartTime && cachedRoomStartTime) {
                console.log('🔄 [ROOM TIME LIMIT] Using cached roomStartTime from previous connection');
                roomStartTime = cachedRoomStartTime;
                store.dispatch(setRoomStartTime(cachedRoomStartTime));
            }
            if (!roomStartTime) {
                try {
                    const storedStartTime = localStorage.getItem('didar_roomStartTime');
                    if (storedStartTime) {
                        console.log('🔄 [ROOM TIME LIMIT] Restoring roomStartTime from localStorage');
                        roomStartTime = storedStartTime;
                        store.dispatch(setRoomStartTime(storedStartTime));
                    }
                }
                catch {
                    // ignore storage errors
                }
            }
            if (roomStartTime) {
                console.log('✅ [ROOM TIME LIMIT] roomStartTime exists, starting timers');
                // Cache it for potential reconnects
                cachedRoomStartTime = roomStartTime;
                store.dispatch(startRoomTimeLimitTimers());
            }
            else {
                console.warn('⚠️ [ROOM TIME LIMIT] No roomStartTime in state, timers not started');
                console.warn('⚠️ [ROOM TIME LIMIT] This might be a reconnect or the state was cleared');
            }
            break;
        }
        case CONFERENCE_WILL_LEAVE: {
            console.log('👋 [ROOM TIME LIMIT] CONFERENCE_WILL_LEAVE event received, cleaning up');
            store.dispatch(cleanupRoomTimeLimitTimers());
            store.dispatch(hideRoomTimeLimitWarning());
            store.dispatch(hideFinalCountdown());
            // Don't clear roomStartTime here - keep it for potential reconnects
            // Only clear the UI state
            // store.dispatch(clearRoomTimeLimit());
            console.log('👋 [ROOM TIME LIMIT] Keeping roomStartTime for potential reconnects');
            break;
        }
    }
    return result;
});
